import React from 'react';
import { Divider } from 'semantic-ui-react';
import { uniqueKey } from '../../../common/keys';
import { gEnums } from '../../../enums/globalEnums';
import { settingsActionTypes } from '../../enums/itemActionTypes';
import { FetchButton } from './FetchButton';

const sats = settingsActionTypes

export const fetchButton_via = (fbProps, actionName) => {
  const { previewClicked, previewInfo, confirmation, handlePreviewClicked, handleItemHelp, reset } = fbProps
  return <FetchButton
    key={uniqueKey('vida', 'fb', actionName)}
    actionName={actionName}
    previewClicked={previewClicked}
    previewReady={(previewInfo || confirmation) ? true : false}
    handlePreview={handlePreviewClicked}
    handleItemHelp={handleItemHelp}
    handleReset={reset}
  />
}

/**
 * an object of actionButtons
 * each item in the array will be a menu item
 */
const actionButtons = {
  homeActions: [sats.createClient],
  baseSettings: [sats.baseForms, sats.baseSettings, sats.currentSettings],
  clientCreate: [sats.createClient],
  clientActions: [sats.createEvent, sats.updateEventStatus, sats.deleteClient],
  clientToProd: [sats.pushClientToProduction],
  copy: [sats.copyViewItemSettingsToViews, sats.copyViewItemSettingsFromDatabase],
  deleteBucket: [sats.deleteBucket],
  eventActions: [sats.deleteEvent, sats.copyEvent],
  fixAllSettings: [sats.fixAllSettings],
  googleAction: [sats.updateDataFromGoogleData, sats.updateDataFromGoogleSheets, sats.updateSettingsFromGoogleSheets],
  help: [sats.createHelpDocument],
  homeSettings: [sats.backupAllSettings, sats.fixAllSettings, sats.updateAllPageItems],
  recreate: [sats.recreateEvent],
  registration: [sats.restoreSettingsFromRegistration],
  restore: [sats.restoreSettingsFromBackup, sats.restoreSettingsFromPaste],
  settingsAction: [sats.backupSettings, sats.convertSettingsToSeparate, sats.fixSettings, sats.transferSettings],
  // transfer: [sats.transferEventToProduction, sats.transferSettingsToProduction, sats.transferDataToProduction, sats.transferSettings],
}

/**
 * returns (via callback) the buttons for viType
 * @param {string} viType 
 * @param {object} fbProps fetch button props
 * @param {function} callback 
 */
export const getAppAreaActionButtons = (viType, fbProps, callback) => {
  const abs = []
  switch (viType) {
    case gEnums.viewSettingTypes.appActions:
      buttons_appActions(abs, fbProps)
      break;
    case gEnums.viewSettingTypes.googleActions:
      // buttons_googleActions(abs, fbProps)
      break;
    case gEnums.viewSettingTypes.settingsActions:
      buttons_settingsActions(abs, fbProps)
      break;
    case gEnums.viewSettingTypes.baseSettings:
      buttons_settingsViewer(abs, fbProps)
      break;
    default:
      break;
  }
  callback(abs)
}

const ammendButtonGroup = (abs, btns, fbProps, caption, index) => {
  abs.push(<Divider key={uniqueKey('vida', 'd', index)} horizontal>{caption}</Divider>)
  ammendBtns(abs, btns, fbProps)
}

const ammendBtns = (abs, btns, fbProps) => {
  btns.forEach(btn => {
    abs.push(fetchButton_via(fbProps, btn))
  })
}

/**
 * loads abs with fetchButtons for the settingsView actions
 * @param {object} abs 
 * @param {object} fbProps 
 */
const buttons_settingsViewer = (abs, fbProps) => {
  if (fbProps.isGlobal) {
    ammendButtonGroup(abs, actionButtons.baseSettings, fbProps, 'Settings Viewer', 10)
  }
}

/**
 * loads abs with fetchButtons for the settingsActions actions
 * @param {object} abs 
 * @param {object} fbProps 
 */
const buttons_settingsActions = (abs, fbProps) => {

  const { appArea, isGlobal, allowResetSettings, allowCopySettings, viType } = fbProps

  if (isGlobal) {
    if (allowResetSettings) {

      ammendButtonGroup(abs, actionButtons.settingsAction, fbProps, appArea + ' Settings', 0)

      if (appArea === gEnums.appAreaTypes.home) {
        ammendButtonGroup(abs, actionButtons.help, fbProps, appArea + ' Help', 1)
      }

      ammendButtonGroup(abs, actionButtons.restore, fbProps, appArea + ' Restore App Settings', 2)

      switch (fbProps.appArea) {
        case gEnums.appAreaTypes.event:
          ammendButtonGroup(abs, actionButtons.registration, fbProps, appArea + ' Registration', 3)
          break;
        default:
        // nothing
      }

      ammendButtonGroup(abs, actionButtons.deleteBucket, fbProps, appArea + ' Storage', 4)

    }
  }

  switch (appArea) {
    case gEnums.appAreaTypes.home:
      switch (viType) {
        case gEnums.viewSettingTypes.settingsActions:
          ammendButtonGroup(abs, actionButtons.homeSettings, fbProps, 'All Settings', 11)
          // ammendButtonGroup(abs, actionButtons.serviceAccount, fbProps, 'URL')
          break;
        default:
        // nothing 
      }
      break;

    case gEnums.appAreaTypes.client:
      switch (viType) {
        case gEnums.viewSettingTypes.settingsActions:
          if (allowCopySettings) {
            ammendButtonGroup(abs, actionButtons.copy, fbProps, 'Copy', 12)
          }
          ammendButtonGroup(abs, actionButtons.fixAllSettings, fbProps, 'Fix Settings', 13)
          break;
        default:
        // nothing
      }
      break;
    default:
    // nothing
  }
}

/**
 * loads abs with fetchButtons based on the appArea
 * @param {object} abs 
 * @param {object} fbProps 
 */
const buttons_appActions = (abs, fbProps) => {

  const { appArea, allowResetSettings } = fbProps

  switch (appArea) {

    case gEnums.appAreaTypes.home:
    case gEnums.appAreaTypes.clients:
      if (allowResetSettings) {
        ammendButtonGroup(abs, actionButtons.clientCreate, fbProps, appArea + ' Actions', 14)
      }
      break;

    case gEnums.appAreaTypes.client:
      ammendButtonGroup(abs, actionButtons.clientActions, fbProps, appArea + ' Actions', 15)
      if (allowResetSettings) {
        ammendButtonGroup(abs, actionButtons.clientToProd, fbProps, appArea + ' Production', 16)
      }
      break;

    case gEnums.appAreaTypes.event:

      if (allowResetSettings) {
        ammendButtonGroup(abs, actionButtons.eventActions, fbProps, appArea + ' Delete', 16)
      }
      break;
    default:
    // nothing 
  }
}
